/**
 * Wave 29 Chunk 4 — Badge chip.
 *
 * Compact pill rendering a single earned badge with a tier-coloured ring,
 * an icon, the label, and an optional "+1 today" annotation.
 */
import { Flame, Wrench, Camera, MapPin, Award, Star } from "lucide-react";

const ICONS = {
  "flame": Flame,
  "wrench": Wrench,
  "camera": Camera,
  "map-pin": MapPin,
  "award": Award,
  "star": Star,
};

const TIER_STYLES = {
  bronze: "border-amber-700/50 bg-amber-700/10 text-amber-300",
  silver: "border-slate-300/40 bg-slate-300/[0.06] text-slate-200",
  gold:   "border-yellow-300/60 bg-yellow-300/[0.08] text-yellow-200",
};

export default function BadgeChip({ badge, size = "md" }) {
  if (!badge) return null;
  const Icon = ICONS[badge.icon] || Award;
  const tier = TIER_STYLES[badge.tier] || TIER_STYLES.bronze;
  const sz = size === "sm"
    ? "text-[10px] px-2 py-0.5"
    : size === "lg"
      ? "text-sm px-3 py-1.5"
      : "text-xs px-2.5 py-1";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border ${tier} ${sz}`}
      title={badge.description || badge.label}
      data-testid={`badge-chip-${badge.id || badge.badge_id || "x"}`}
    >
      <Icon className={size === "lg" ? "w-4 h-4" : "w-3 h-3"} />
      {badge.label}
    </span>
  );
}
